/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link, withRouter} from 'react-router-dom'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import moment from 'moment-jalaali'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import TMS from '../BaseComponent/TMS'
import {convertMinuteToHour, roundTo} from '../utils/convert'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'

class DetailsActivityFunctionality extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      printInfo: [],
      lengthProducts: 0,
      countAll: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      modalDelete: false,
      fromDate: '',
      toDate: '',
      sortData: [
        {name: 'ردیف', value: 'id', sorted: false, direction: null, sortable: false},
        {name: 'کاربر', value: 'title', sorted: false, direction: null, sortable: false},
        {name: 'دپارتمان', value: 'departmentTitle', sorted: false, direction: null, sortable: false},
        {name: 'بخش', value: 'sectionTitle', sorted: false, direction: null, sortable: false},
        {name: 'فعالیت', value: 'taskTitle', sorted: false, direction: null, sortable: false},
        {name: 'تامین کننده', value: 'providerTitle', sorted: false, direction: null, sortable: true},
        {name: 'کالا', value: 'productTitle', sorted: false, direction: null, sortable: true},
        {name: 'بازه زمانی', value: 'taskTimeMinuteMin', sorted: false, direction: null, sortable: true},
        {name: 'وضعیت', value: 'state', sorted: false, direction: null, sortable: true},
        {name: 'تاریخ ثبت', value: 'creationTime', sorted: false, direction: null, sortable: true},
        {name: 'تعداد', value: 'count', sorted: false, direction: null, sortable: true},
        {name: 'تاریخ فعالیت', value: 'activityDate', sorted: false, direction: null, sortable: true},
        {name: 'زمان تخمینی', value: 'timeMinuteUser', sorted: false, direction: null, sortable: true},
        {name: 'زمان مورد تایید', value: 'timeMinuteOperator', sorted: false, direction: null, sortable: true},
        {name: 'توضیحات', value: 'description', sorted: false, direction: null, sortable: true}
        // {name : 'نمودار', value : '' , sorted : false ,direction : null,sortable : false},
      ],
      department: [],
      operators: [],
      personId: {
        personId: ''
      },
      detailsModal: false,
      detailsData: [],
      id: '',
      sortby: ''
    }
  }

  changePageSize = (e) => {
    let value = e.target.value
    let {id} = this.state

    let parameter = sessionStorage.getItem('params')
    sessionStorage.setItem('dropDownVal', value)
    sessionStorage.setItem('pageNumber', 1)
    parameter = parameter + id + '&pageSize=' + value
    http
      .get(`${TMS.TMS_REPORT_ACTIVITY_FUNCTIONALITY_DETAIL}?export=false&pageNumber=1&${parameter}`, {})
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            detailsData: res.data.object.result,
            countAll: res.data.object.countAll,
            detailsModal: true
          })
        }
      })
  }

  getAll = (id) => {
    let parameter = sessionStorage.getItem('params')
    sessionStorage.setItem('dropDownVal', 10)
    sessionStorage.setItem('pageNumber', 1)
    // let { id } = this.props.match.params;

    parameter = parameter + id + '&pageSize=10&' + 'sortBy=' + this.state.sortby

    http
      .get(`${TMS.TMS_REPORT_ACTIVITY_FUNCTIONALITY_DETAIL}?export=false&pageNumber=1&${parameter}`, {})
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            detailsData: res.data.object.result,
            countAll: res.data.object.countAll,
            detailsModal: true
          })
        }
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.basketFilterComponent').slideUp()
      })
    })
    let urlParams = new URLSearchParams(window.location.search)
    let id = urlParams.get('id') === null ? '' : urlParams.get('id')
    this.setState({
      id
    })
    let fromDate = urlParams.get('fromDate') === null ? '' : urlParams.get('fromDate')
    let toDate = urlParams.get('toDate') === null ? '' : urlParams.get('toDate')
    this.setState({
      fromDate: fromDate === '' ? '' : jMoment(Number(this.convertDigit(fromDate))).format('jYYYY/jMM/jDD'),
      toDate: toDate === '' ? '' : jMoment(Number(this.convertDigit(toDate))).format('jYYYY/jMM/jDD')
    })

    this.getAll(id)
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    let urlParams = new URLSearchParams(window.location.search)
    let id = urlParams.get('id') === null ? '' : urlParams.get('id')
    if (this.state.sortby !== prevState.sortby) {
      this.getAll(id)
    }
  }

  statusColor = (timeMinuteUser, taskTimeMinuteMin, taskTimeMinuteMax, count) => {
    if (timeMinuteUser < taskTimeMinuteMin * count) {
      return '#d4fcc3'

      //red
    } else if (timeMinuteUser > taskTimeMinuteMax * count) {
      return '#fbd9d9'
    } else {
      return ''
    }
  }
  convertState = (state) => {
    switch (state) {
      case 100:
        return 'در انتظار'
        break
      case 10:
        return <img src={require('../../image/confirm.svg')} style={{width: '20px'}} />
        break
      case 20:
        return <img src={require('../../image/ignor.svg')} style={{width: '20px'}} />
        break
      default:
        return '-'
    }
  }
  onResultFetched(data) {
    this.setState({
      detailsData: data
    })
  }

  changeDropDown(data) {
    this.setState({
      detailsData: data,
      countAll: this.state.countAll
    })
  }
  getSort = (sortby) => {
    this.setState({sortby})
  }

  convertCount = (count) => {
    if (count !== null) {
      return count.toFixed(1).replace('.0', '')
    } else {
      return ''
    }
  }

  render() {
    let parameter = sessionStorage.getItem('params')
    let {id} = this.state
    parameter = parameter + id + '&pageSize=' + sessionStorage.getItem('dropDownVal')

    // let {pageNumber,pageSize} = this.state;
    let pageNumber = sessionStorage.getItem('pageNumber')
    let pageSize = sessionStorage.getItem('dropDownVal')
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'عنوان',
      'حداقل زمان',
      'میانگین زمان',
      'حداکثر زمان',
      'تعداد فعالیت',
      'تعداد روزکاری',
      'مدت زمان اعلامی',
      'مدت زمان تایید شده',
      'مدت زمان تایید نشده',
      'مدت زمان بررسی نشده',
      'نسبت تایید شده ها به کل'
    ]

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش عملکرد"
              headerColSpan={13}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={8}
              rightColSpan={4}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{list.title}</td>
                  <td>{convertMinuteToHour(list.timeMinuteMin)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteAvg)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteMax)}</td>
                  <td>{this.convertCount(list.activityCount)}</td>
                  <td>{list.dayCount}</td>
                  <td>{convertMinuteToHour(list.timeMinuteUser)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteOperatorAccept)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteOperatorReject)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteOperatorDraft)}</td>
                  <td>{roundTo(list.timeMinuteOperatorAcceptRatio)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش عملکرد.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'timeMinuteMin'}
                field={'timeMinuteMin'}
                title={'حداقل زمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteAvg'}
                field={'timeMinuteAvg'}
                title={'میانگین زمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteMax'}
                field={'timeMinuteMax'}
                title={'حداکثر زمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activityCount'}
                field={'activityCount'}
                title={'تعداد فعالیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activityCount'}
                field={'dayCount'}
                title={'کارکرد روزانه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteUser'}
                field={'timeMinuteUser'}
                title={'مدت زمان اعلامی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteOperatorAccept'}
                field={'timeMinuteOperatorAccept'}
                title={'مدت زمان تایید شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteOperatorReject'}
                field={'timeMinuteOperatorReject'}
                title={'مدت زمان تایید نشده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteOperatorDraft'}
                field={'timeMinuteOperatorDraft'}
                title={'مدت زمان بررسی نشده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'timeMinuteOperatorAcceptRatio'}
                field={'timeMinuteOperatorAcceptRatio'}
                title={'نسبت تایید شده ها به کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت فعالیت ها</li>
            <li>گزارشات</li>
            <li>گزارش عملکرد</li>
            <li>جزییات</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <div className="optionButtons">
                  <select id="dropDownVal" onChange={this.changePageSize.bind(this)}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200" selected={this.props.defaultValuePageSize === '200' ? true : false}>
                      200
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="showBaseTable">
              <div className="detailsInfoTable">
                <ul>
                  <li>تاریخ از : {this.state.fromDate}</li>
                  <li>تاریخ تا : {this.state.toDate}</li>
                </ul>
              </div>
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.detailsData.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: this.statusColor(
                          item.timeMinuteUser,
                          item.taskTimeMinuteMin,
                          item.taskTimeMinuteMax,
                          item.count
                        )
                      }}
                    >
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.user !== null && item.user.name}</td>
                      <td>{item.departmentTitle}</td>
                      <td>{item.sectionTitle}</td>
                      <td>{item.taskTitle}</td>
                      <td>{item.providerTitle}</td>
                      <td>{item.productTitle}</td>
                      <td>{item.taskTimeMinuteMin + ' - ' + item.taskTimeMinuteMax + ' دقیقه '}</td>
                      <td>{this.convertState(item.state)}</td>
                      <td>{jMoment(item.creationTime).format('jYYYY/jMM/jDD')}</td>
                      <td>{this.convertCount(item.count)}</td>
                      <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                      <td>{this.convertCount(item.timeMinuteUser) + ' دقیقه '}</td>
                      <td>{item.state === 10 && this.convertCount(item.timeMinuteOperator) + ' دقیقه '}</td>

                      <td title={item.description}>
                        {item.description !== null && item.description.substr(0, 5) + '...'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  urlParams={parameter}
                  url={TMS.TMS_REPORT_ACTIVITY_FUNCTIONALITY_DETAIL}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(DetailsActivityFunctionality)
